<template>
  <el-dialog
    :model-value="dialog"
    :before-close="handlerClose"
    width="25%"
    class="dialogAttachPost"
  >
          <el-row class="addAttach-main-div">
            <el-col :span="24" style="display: flex; justify-content: space-between; align-items: center;">
              <span class="addAttach-header"> {{$t('posts.attachFile')}} </span>
              <el-upload
                  action=""
                  :auto-upload="false"
                  multiple
                  :on-change="fileChange"
                  :show-file-list="false"
                  :limit="10"
              >
                <button class="addAttach-add-file-button">{{$t('posts.addFile')}}</button>
              </el-upload>
            </el-col>
            <el-col :span="24">
              <div class="divContent">
                <el-table
                    :data="attachment"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                >
                  <el-table-column prop="type" label="" width="50">
                    <template #default="scope">
                      <attachment-Icon :type="scope.row.type"></attachment-Icon>
                    </template>
                  </el-table-column>
                  <el-table-column prop="createDate" label="Date">
                  </el-table-column>
                  <el-table-column prop="name" label="Name">
                  </el-table-column>
                  <el-table-column type="selection" width="55"> </el-table-column>
                </el-table>
              </div>
            </el-col>
            <el-col :span="24">
              <button @click="save" class="addAttach-save-button">{{$t('posts.attach')}}</button>
            </el-col>
          </el-row>
  </el-dialog>
</template>

<script>
import AttachmentIcon from "./attachmentIcon"
export default {
  props: ["dialog", "attachDialogOpenAndPostDontCreated"],
  emits: ["closeDialog", "attachAttachment"],
  data() {
    return {
      dialogTableVisible: false,
      attachment: [],
      uploadAttachment: [],
      result: [],
    };
  },
  components: {
    "attachment-Icon": AttachmentIcon
  },
  watch: {
    dialog(newVal) {
      if (newVal) this.getAttachment();
    },
  },
  methods: {
    handlerClose() {
      this.$emit("closeDialog");
    },
    async getAttachment() {
      if (!this.attachDialogOpenAndPostDontCreated) {
        this.attachment = [];
        this.attachment = (await this.$http.get("api/Attach/GetMyAttach")).data;
      }
    },
    handleSelectionChange(val) {
      this.result = val;
    },
    save() {
      this.$emit(
        "attachAttachment",
        this.result
      );
    },
    async fileChange(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
        await this.$http({
          method: "POST",
          url: "api/Attach/uploadFile",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        })
      this.getAttachment()
    },
  },
};
</script>

<style>
.dialogAttachPost > .el-dialog__header {
  display: none;
}
.dialogAttachPost> .el-dialog__body {
  padding: 0;
}
.dialogAttachPost{
  box-shadow: none;
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: 400;
  color: var(--file-text);
  background: var(--file-background);
}
.addAttach-main-div{
  padding: 20px 15px;
}
.addAttach-main-div .addAttach-header{
  font-size: 20px;
  color: var(--file-text);
  line-height: 24px;
  font-weight: 700;
}
.addAttach-main-div .addAttach-add-file-button{
  background: #E6F1FF;
  border-radius: 5px;
  padding: 11px 20px;
  border: none;
  outline: none;
  font-size: 15px;
  color: var(--blueColor);
}
.el-table{
  background: var(--file-background);
}
.el-table th, .el-table tr {
  background: var(--file-background);
  color: var(--file-text);
}
.el-table th, .el-table tr .el-table__cell{
  background: var(--file-background);
}
.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
  background: var(--file-background);
}
.el-table--enable-row-hover .el-table__body tr:hover>td{
  background: var(--file-background);
}
.addAttach-main-div .addAttach-save-button{
  background: #006EFF;
  border-radius: 5px;
  width: 100%;
  padding: 15px 0;
  border: none;
  outline: none;
  color:var(--whiteText);
}
.tabSearch > input {
  background: var(--file-background);
  border: 1px solid #e8e8ec;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #0b131b;
  height: 52px;
}
.tabSearch {
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 16px;
}
</style>
<style scoped>
.divContent {
  min-height: 300px;
  height: 300px;
  overflow-y: auto;
}
.tabs {
  width: 100%;
}
.tabs > input[type="radio"] {
  display: none;
}
.tabs > input[type="radio"]:checked + label {
  color: #0b131b;
  opacity: 1;
}
.tabs > .divContent {
  /* скрыть контент по умолчанию */
  display: none;
  padding: 10px 15px;
  border-radius: 4px;
}
/* отобразить контент, связанный с вабранной радиокнопкой (input type="radio") */
#tab-btn-1:checked ~ #content-1,
#tab-btn-2:checked ~ #content-2,
#tab-btn-3:checked ~ #content-3 {
  display: block;
}
.tabs > label {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: white;
  border: 1px solid transparent;
  padding: 2px 8px;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
  margin-left: 6px;
  cursor: pointer;
  margin-bottom: 10px;
  font-family: Helvetica;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  opacity: 0.5;
}
.tabs > label:first-of-type {
  margin-left: 0;
}
.divContent::-webkit-scrollbar-track {
  border: 1px solid #000;
  padding: 2px 0;
  background-color: #404040;
}
.divContent::-webkit-scrollbar {
  width: 10px;
}
.divContent::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #737272;
  border: 1px solid #000;
}
</style>
